/**
 * TextHighlight.js
 */

import { gsap, Power2 } from 'gsap';
import 'intersection-observer';

export default class TextHighlight {


  constructor(textEl) {
    this.textEl = textEl;
    this.highlightBg = this.textEl.querySelector('.text-highlight-bg');
    this.onScroll = this.onScroll.bind(this);
    this.setBuffer = this.setBuffer.bind(this);
    
    this.setBuffer();

    let previousY = 0;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const currentY = entry.boundingClientRect.y;
        
        if (entry.isIntersecting) {
          if (currentY < previousY) this.setBuffer();

          window.addEventListener('scroll', this.onScroll);
          window.addEventListener('resize', this.setBuffer);
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.setBuffer);
        }

        previousY = currentY;
      });
    });

    observer.observe(this.textEl);
  }

  setBuffer() {
    this.buffer = this.getBuffer();
  }

  getBuffer() {
    const viewportHeight = window.innerHeight;
    const elementOffsetTop = this.textEl.getBoundingClientRect().top;
    const elementHeight = this.textEl.offsetHeight;
    const distance = viewportHeight - elementOffsetTop;
    const percentage = Math.round( distance / ( (viewportHeight + elementHeight) / 100 ) );
    const buffer = ( 100 - Math.min( 100, Math.max(0, percentage) ) ) / 100;

    return buffer;
  }

  onScroll() {
    const elementTop = this.textEl.getBoundingClientRect().top + document.documentElement.scrollTop;
    const viewportBottom = window.pageYOffset + (window.innerHeight * this.buffer);
    const totalView = window.innerHeight + this.highlightBg.clientHeight;

    if (window.pageYOffset > elementTop + this.highlightBg.clientHeight) return;

    const total = ( ( (viewportBottom - elementTop) / totalView ) * 2 ).toFixed(2);

    let scaleX;

    if (total < 0.1) scaleX = 0;
    else if (total < 0.9) scaleX = total;
    else if (total >= 0.9 && total <= 1) scaleX = 1;

    gsap.to(this.highlightBg, {
      scaleX: scaleX,
      ease: Power2.easeOut,
      duration: 0,
    });
  }
}
